// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HW-z","hovered":"IW-z","hoverImage":"JW-z","mainImage":"KW-z","imageNoBackground":"LW-z","fullSizeImage":"MW-z"};